


export class RentalTable {
  header: {
    text: string;
    count: number;
  }[]
  items: Item[]
}

export class Item {
  id: number;
  groupName: string;
  itemName: string;
  storageName: string;
  count: number;
  storage: {
    name: string;
  };
  policy: {
    times: {
      start: string;
      end: string;
    }[]
  };
}

export class RentalReservation {
  id: number;
  email: string;
  item: Item;
  time_use_start: string;
  time_use_end: string;
  count: number;
  location: string;
  date: string;
}



// WEBPACK FOOTER //
// ./src/app/service/rental/rental.ts